export default "__VITE_ASSET__CtpzgCYo__"